import { b as _inherits, c as _createSuper, d as _createClass, _ as _defineProperty, e as _classCallCheck } from './_rollupPluginBabelHelpers-e84dd01a.js';
import React, { createContext, Component } from 'react';
import PropTypes from 'prop-types';
import Rollbar from 'rollbar';
import { i as invariant } from './tiny-invariant.esm-a43f84cc.js';

var Context = /*#__PURE__*/createContext();
Context.displayName = 'Rollbar';
var RollbarInstance = Symbol('RollbarInstance');
var BaseOptions = Symbol('BaseOptions');
var RollbarCtor = Symbol('RollbarCtor');
function getRollbarFromContext(context) {
  var rollbar = context[RollbarInstance];
  return rollbar;
}
function getRollbarConstructorFromContext(context) {
  var ctor = context[RollbarCtor];
  return ctor;
}
var Provider = /*#__PURE__*/function (_Component) {
  _inherits(Provider, _Component);

  var _super = _createSuper(Provider);

  function Provider(props) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _super.call(this, props);
    var _this$props = _this.props,
        config = _this$props.config,
        _this$props$Rollbar = _this$props.Rollbar,
        ctor = _this$props$Rollbar === void 0 ? Rollbar : _this$props$Rollbar,
        instance = _this$props.instance;
    invariant(!instance || instance instanceof Rollbar, 'providing `instance` must be of type Rollbar');
    var options = typeof config === 'function' ? config() : config;
    var rollbar = instance || new ctor(options); // TODO: use isUncaught to filter if this is 2nd Provider added
    // unless customer wants that

    _this.state = {
      rollbar: rollbar,
      options: options
    };
    return _this;
  } // componentDidUpdate()


  _createClass(Provider, [{
    key: "render",
    value: function render() {
      var _ref;

      var _this$props2 = this.props,
          children = _this$props2.children,
          _this$props2$Rollbar = _this$props2.Rollbar,
          ctor = _this$props2$Rollbar === void 0 ? Rollbar : _this$props2$Rollbar;
      var _this$state = this.state,
          rollbar = _this$state.rollbar,
          options = _this$state.options;
      return /*#__PURE__*/React.createElement(Context.Provider, {
        value: (_ref = {}, _defineProperty(_ref, RollbarInstance, rollbar), _defineProperty(_ref, BaseOptions, options), _defineProperty(_ref, RollbarCtor, ctor), _ref)
      }, children);
    }
  }]);

  return Provider;
}(Component);

_defineProperty(Provider, "propTypes", {
  Rollbar: PropTypes.func,
  config: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  instance: PropTypes.instanceOf(Rollbar)
});

export { Context, Provider, getRollbarConstructorFromContext, getRollbarFromContext };
//# sourceMappingURL=Provider.js.map
